import Alpine from "alpinejs";

Alpine.data("buttons", () => ({
    uuid: null,
    buttonsInstances: {},


    init(items, configuration, uuid) {

        if (uuid) {
            this.uuid = uuid;
            // Initialize the buttonsInstances if not already present
            if (!this.buttonsInstances[uuid]) {
                this.buttonsInstances[uuid] = {
                    buttons: items,
                    styles : {
                        buttons: configuration
                    }
                };
            }
        }

        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-buttons') {
                let json = JSON.parse(event.data.data);

                if (this.buttonsInstances[json.id]) {
                    if (json.buttons) this.buttonsInstances[json.id].buttons = json.buttons;
                    if (json.styles) this.buttonsInstances[json.id].styles = json.styles;
                }
            }
        });
    },

    getContainerStyles(uuid) {
        const instance = this.buttonsInstances[uuid];
        return {
            gap: instance?.styles.buttons.gap + 'px',
            flexDirection: instance?.styles.buttons.direction
        };
    },

    getButtonHref(button) {
        switch (button.linkType) {
            case 'email':   return 'mailto:' + button.email;
            case 'tel':     return 'tel:' + button.tel;
            case 'external': return button.external;
            case 'anchor':  return '#' + button.anchor;
            case 'internal': return button.link;
            default:        return '#';
        }
    },

    getIconStyles(button, isHovered) {
        // Safe access to nested style properties
        const iconStyles = button.styles?.iconColor;

        return {
            visibility: 'visible',
            color: isHovered
                ? (iconStyles?.hover || iconStyles?.normal)
                : iconStyles?.normal
        };
    },

    getButtonStyles(button) {
        if (button.styles) {
            const buttonStyles = button.styles;
            let styles = '';

            if (buttonStyles.textColor && buttonStyles.textColor.normal) {
                styles = 'color: ' + buttonStyles.textColor.normal;
            }
            if (buttonStyles.backgroundColor && buttonStyles.backgroundColor.normal) {
                styles = styles + '; background: ' + buttonStyles.backgroundColor.normal;
            }
            if (buttonStyles.borderWidth && buttonStyles.borderWidth.normal) {
                styles = styles + '; border: ' + buttonStyles.borderWidth.normal + 'px solid';
            }
            if (buttonStyles.borderColor && buttonStyles.borderColor.normal) {
                styles = styles + buttonStyles.borderColor.normal + ';'
            }
            return this.getGlobalButtonStyles(styles);
        }
    },

    getButtonHoverStyles(button) {
        if (button.styles) {
            const buttonStyles = button.styles;
            let styles = '';

            if (buttonStyles.textColor.hover || buttonStyles.textColor.normal) {
                styles = 'color: ' + (buttonStyles.textColor.hover || buttonStyles.textColor.normal);
            }
            if (buttonStyles.backgroundColor.hover || buttonStyles.backgroundColor.normal) {
                styles += '; background: ' + (buttonStyles.backgroundColor.hover || buttonStyles.backgroundColor.normal);
            }
            if (buttonStyles.borderWidth.hover || buttonStyles.borderWidth.normal) {
                styles += '; border: ' + (buttonStyles.borderWidth.hover || buttonStyles.borderWidth.normal) + 'px solid';
            }
            if (buttonStyles.borderColor.hover || buttonStyles.borderColor.normal) {
                styles += ' ' + (buttonStyles.borderColor.hover || buttonStyles.borderColor.normal) + ';';
            }

            return this.getGlobalButtonStyles(styles);
        }
    },

    getGlobalButtonStyles(styles) {
        const textSizeConfig = this.buttonsInstances[this.uuid].styles.buttons.textSize;

        if (textSizeConfig) {
            const desktopSize = textSizeConfig.desktop ? textSizeConfig.desktop + 'px' : ''
            const tabletSize = textSizeConfig.tablet ? textSizeConfig.tablet + 'px' : desktopSize;
            const mobileSize = textSizeConfig.mobile ? textSizeConfig.mobile + 'px' : tabletSize;

            if (window.matchMedia('(max-width: 767px)').matches) {
                styles = styles + ' ; font-size: ' + mobileSize;
            } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
                styles = styles + ' ; font-size: ' + tabletSize;
            } else {
                styles = styles + ' ; font-size: ' + desktopSize;
            }
        }

        styles = styles + "; font-weight: " + this.buttonsInstances[this.uuid].styles.buttons.fontsAndTypography?.weight;
        styles = styles + `; border-radius: ${this.buttonsInstances[this.uuid].styles.buttons.borderRadius?.topLeft}px ${this.buttonsInstances[this.uuid].styles.buttons.borderRadius?.topRight}px ${this.buttonsInstances[this.uuid].styles.buttons.borderRadius?.bottomRight}px ${this.buttonsInstances[this.uuid].styles.buttons.borderRadius?.bottomLeft}px;`
        styles = styles + '; padding-top: ' + this.buttonsInstances[this.uuid].styles.buttons.padding?.desktop.top + 'px';
        styles = styles + '; padding-bottom: ' + this.buttonsInstances[this.uuid].styles.buttons.padding?.desktop.bottom + 'px';
        styles = styles + '; padding-left: ' + this.buttonsInstances[this.uuid].styles.buttons.padding?.desktop.left + 'px';
        styles = styles + '; padding-right: ' + this.buttonsInstances[this.uuid].styles.buttons.padding?.desktop.right + 'px';
        styles = styles + '; gap: ' + this.buttonsInstances[this.uuid].styles.buttons.iconAndTextGap + 'px';

        return styles;
    }
}));
